import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';
const navigationItems = [
    { name: 'ABOUT US', href: '/about' },
    { name: 'SERVICE', href: '/services' },
    { name: 'WORKS', href: '/works' },
    { name: 'RECRUIT', href: '/recruit' },
    { name: 'CONTACT', href: '/contact' },
];
export default function Footer() {
    const currentYear = new Date().getFullYear();
    const handleLinkClick = () => {
        window.scrollTo(0, 0);
    };
    return (<footer className='bg-navy text-white'>
      {/* Main Footer Content */}
      <div className='section-container py-16 md:py-24'>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12'>
          {/* Company Info */}
          <div>
            <Link to='/' className='text-white font-bebas text-3xl tracking-wider transition-opacity hover:opacity-80' onClick={handleLinkClick}>
              MORIDEN SETSUBI
            </Link>

            <ul className='mt-6 space-y-3 text-white/80'>
              <li className='flex items-start'>
                <MapPin size={18} className='mr-2 mt-1 shrink-0'/>
                <span>〒020-0839 岩手県盛岡市津志田南3-13-15</span>
              </li>
              <li className='flex items-center'>
                <Mail size={18} className='mr-2 shrink-0'/>
                <a href='mailto:info@moriden-setubi.com' className='hover:text-white transition-colors'>
                  info@moriden-setubi.com
                </a>
              </li>
            </ul>
          </div>

          {/* Navigation */}
          <div className='lg:col-span-2'>
            <h2 className='text-xl font-medium mb-6'>サイトマップ</h2>
            <nav className='grid grid-cols-2 gap-x-8 gap-y-4'>
              {navigationItems.map((item) => (<Link key={item.name} to={item.href} className='text-white/80 hover:text-white transition-colors' onClick={handleLinkClick}>
                  {item.name}
                </Link>))}
            </nav>
          </div>

          {/* Contact CTA */}
          <div>
            <h2 className='text-xl font-medium mb-6'>お問い合わせ</h2>
            <p className='text-white/80 mb-6'>
              お見積り・ご相談は無料です。お気軽にお問い合わせください。
            </p>
            <Link to='/contact' className='text-white border border-white/30 px-6 py-3 rounded-full hover:bg-white/10 transition-colors text-sm inline-block' onClick={handleLinkClick}>
              お問い合わせフォームへ
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className='border-t border-white/10'>
        <div className='container mx-auto px-6 py-6'>
          <div className='flex flex-col md:flex-row justify-between items-center text-sm text-white/60'>
            <p>
              © {currentYear} MORIDEN SETSUBI INDUSTRY CO., LTD. All Rights
              Reserved.
            </p>
            <div className='mt-4 md:mt-0 space-x-6'>
              <Link to='/privacy' className='hover:text-white transition-colors' onClick={handleLinkClick}>
                プライバシーポリシー
              </Link>
              <Link to='/terms' className='hover:text-white transition-colors' onClick={handleLinkClick}>
                利用規約
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>);
}
